

<div class="section">
    <div class="container">
      <div class="row">
        <div class="col-md-2 border-right">
          <h2 class="h2">
            WHAT
            <br>
            WE
            <br>
            DO?
          </h2>
        </div>
        <div class="col-md-1"></div>
        <div *ngIf="weDo.length===0"class="col-md-3">
          <h3 class="text-white">EXCELLENCE</h3>
          <p class="text-white pText">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate veli
          </p>
        </div>
        <div *ngFor="let elt of weDo"class="col-md-3">
          <h3 class="text-white">{{elt.title}}</h3>
          <p class="text-white pText" [innerHTML]="elt.description">
          </p>
        </div>
      </div>

    </div>
</div>
